import { Request, TagValidation } from '@/helpers'

import {
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    ENDPOINTS
} from '@/data'

const Update = async (props: ClientTagUpdateFunctionProps) => {
    const {
        Tags,
        SetTagsState,
        Form,
        Errors,
        SetState,
        InitNotification
    } = props

    try {
        const { _id, Name } = Form

        const clone_errors = structuredClone(Errors)

        Object.keys(clone_errors).forEach(key => { clone_errors[key] = true })

        SetState({ Errors: clone_errors })

        const nameIsValid = TagValidation(Name)

        if (!nameIsValid.error) {
            SetState({ Loading: true })

            const sideover_panel = document.querySelector('#sideover-panel')

            if (sideover_panel) sideover_panel.scrollBy({
                top: -sideover_panel.scrollHeight,
                behavior: 'smooth'
            })

            const { success, message, data } = await Request({
                path: ENDPOINTS.UPDATE_TAG,
                method: 'PATCH',
                body: {
                    id: _id,
                    name: Name
                }
            })

            if (success && data) {
                const tags = structuredClone(Tags)
                const index = tags.findIndex(tag => tag._id === _id)

                tags[index] = data
                SetTagsState({ Tags: tags })

                const components_panel = document.querySelector('#component-list')

                if (components_panel) components_panel.scrollBy({
                    top: -components_panel.scrollHeight,
                    behavior: 'smooth'
                })

                InitNotification(message)

                SetState({
                    Form: COMPONENT_DEFAULT_FORM,
                    Errors: COMPONENT_DEFAULT_ERRORS,
                    Loading: false,
                    Mode: 'create',
                    Open: false
                })
            }

            else {
                InitNotification(message)
                SetState({ Loading: false })
            }
        }
    }

    catch (error) {
        console.error(error)

        InitNotification('Something went wrong while trying to update tag!')
        SetState({ Loading: false })
    }
}

export default Update
